export default "__VITE_ASSET__20cd2341__"